<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 24 },
        ]"
      >
        <fetch-story
          :route="cms.api_endpoint || 'en-gb/our-work'"
          :params="{
            sort_by: cms.api_order || null,
            by_uuids: cms.api_filter || null,
          }"
          :limit="parseInt(cms.api_limit) || 0"
          :offset="parseInt(cms.api_offset) || 0"
          :collection="cms.collection"
          entry="content"
        >
          <div
            v-if="(collection || []).length > 0"
            v-editable="cms"
            slot-scope="{ collection }"
            :class="[`${name}__thumbnails`]"
          >
            <div v-for="(item, index) in setThumbnail(collection)" :key="index">
              <m-card-wide
                :cms="{
                  ...item,
                  cta: item.cta.length ? item.cta : setCta(),
                }"
                :tag-list="item.tags"
                :url="item.url"
                :class="[`${name}__thumbnail`]"
              />
            </div>
          </div>
        </fetch-story>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import FetchStory from '~/components/shared/fetch-story'
import MCardWide from '~/components/molecules/m-cards/m-card-wide'
import Thumbnail from '~/mixins/thumbnail'

export default {
  components: { FetchStory, MCardWide },
  mixins: [Colors, Thumbnail],
  props: {
    cms: {
      type: Object,
      default() {},
    },
  },

  data() {
    return {
      name: 'o-list-work',
      show: false,
      style: {
        textColor: '#000000',
        backgroundColor: '#FFFFFF',
        hoverColor: '#C33CA8',
        disabledColor: '#888b8d',
      },
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#FF3476'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
  methods: {
    setCta() {
      if (this.cms.cta && this.cms.cta.length > 0) {
        return this.cms.cta
      }
      return [
        {
          copy: 'See the work.',
          type: 'tertiary',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.o-list-work {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background-color: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);
  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
  ::v-deep a {
    &:hover,
    &:active {
      h4 {
        color: var(--hover-color);
      }

      .grid-item picture img {
        scale: 1.1;
      }
    }
  }
  ::v-deep .a-cta {
    &:hover,
    &:active {
      color: var(--text-color);
    }
  }

  &__thumbnails {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 80px 40px;
  }
}

@include media-breakpoint-up(md) {
  .o-list-work {
    // padding: 30px 0;

    &__thumbnails {
      grid-gap: 80px 40px;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
  }
}
</style>
